// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__2YgsO","spinnerContainer":"loader_spinnerContainer__3SSMC","rotation":"loader_rotation__2rBZI","LoaderSpinner":"loader_LoaderSpinner__dYC7i"};